import { Component, HostBinding, Input } from '@angular/core';
import {CommonModule} from "@angular/common";

@Component({
  selector: 'colimo-icons',
  styleUrls: ['icons.component.scss'],
  templateUrl: 'icons.component.html',
  imports: [
    CommonModule
  ]
})
export class IconsComponent {
  @Input() public icon = '';

  @Input() public direction = 'up';

  @Input() public altText = 'icon';

  @HostBinding('style.width')
  @Input()
  public width = '16px';

  @HostBinding('style.height')
  @Input()
  public height = '16px';

  @HostBinding('style.top')
  @Input()
  public top = '0';

  constructor() {}

}
